<template>
  <div class="relative table-wr bg-base-0 rounded  ">
    <div class="p-4">
      <aha-input
        v-if="reportMetric && reportMetric.totalAudience >0 "
        :placeholder="getAudienceSearchPlaceHolder"
        class="cursor-pointer font-normal text-base search_audience_name"
        v-model="searchValue"
        @input="_onSearchInput"
        ref="search"
        autocomplete="new-password"
      >
        <template #append>
          <aha-icon
            name="search"
            class="search__icon absolute top-0 flex items-center h-10 left-2"
            width="16"
            height="16"
            viewBox="0 0 24 24"
          />
          <aha-icon
            name="close"
            class="clear__icon absolute top-0 flex items-center h-10
            text-base-60 right-2 hidden "
            width="16"
            height="16"
            viewBox="0 0 24 24"
          />
        </template>
      </aha-input>
    </div>
    <div
      v-if="reportMetric && reportMetric.totalAudience === 0 && !isLoadingReport"
      class="w-full text-center flex justify-center items-center h-full  wrapper-empty"
    >
      <div>
        <div class="empty-title mb-2">
          {{ $i18nPresenter.t('No engagement yet!') }}
        </div>
        <div class="empty-decs">
          {{ $i18nPresenter.t('Invite people to join your presentation and start engaging!') }}
        </div>
      </div>
    </div>
    <div class="table-wrp block " v-else>
      <table class="w-full  text-left  text-gray-500 ">
        <thead class="text-xs text-gray-700  ">
          <tr>
            <th class="h-11 w-10">
            </th>
            <th scope="row" class="audience-name__header-row spacing-col">
              {{ $i18nPresenter.t('Name') }}
            </th>
            <th class="w-leaderboard " v-if=" totalAnswer > 0 ">
              {{ $i18nPresenter.t('Leaderboard') }}
            </th>
            <th scope="row" v-if=" totalAnswer > 0 " class="px-10">
              {{ $i18nPresenter.t('Accuracy') }}
            </th>
            <th scope="row" class="total-submissions__header-row spacing-col" colspan="2">
              {{ $i18nPresenter.t('Total submissions') }}
            </th>
          </tr>
        </thead>
        <tbody v-if="isLoadingAudience">
          <tr>
            <td v-for="(item , index) in [1,2,3,4,5]" :key="index">
              <div>
                <span
                  class="flex flex-col mt-1"
                >
                  <aha-skeleton-loader
                    class="mb-2"
                    width="100"
                    height="40px"
                  />
                  <aha-skeleton-loader
                    class="mb-2"
                    width="100%"
                    height="40px"
                  />
                  <aha-skeleton-loader
                    class="mb-2"
                    width="100%"
                    height="40px"
                  />
                  <aha-skeleton-loader
                    class="mb-2"
                    width="100%"
                    height="40px"
                  />
                  <aha-skeleton-loader
                    class="mb-2"
                    width="100%"
                    height="40px"
                  />
                </span>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else class="overflow-y-scroll">
          <tr
            v-for="(audience , index ) in listParticipants"
            :key="index"
            class="audience-row"
            name="report-audience-row"
            v-aha-emit-action="{ audienceId: audience.audienceId }"
            @click="audienceRowClick(audience)"
          >
            <td scope="row" class="order-number">
              {{ audience.index }}
            </td>
            <td class="font-bold item-name-participant spacing-col">
              <div class="truncate name-audience  ">
                {{ audience.audienceName }}
              </div>
            </td>
            <td class="total-label-rank" v-if="totalAnswer && totalAnswer > 0 ">
              <div class="text-left">
                {{ formatNumberForPoint(audience.totalPoint) }}
              </div>
              <div :class="`${textRanking(audience.rank, audience).class }  rounded-xl flex text-base`">
                <div class=" label-ranking">
                  {{ textRanking( audience.rank, audience).name }} {{ textRanking(audience.rank, audience).icon }}
                </div>
              </div>
            </td>
            <td class="font-bold td-accuracy px-10 " v-if="totalAnswer && totalAnswer > 0 ">
              <div class="wrapper-process-bar-quiz">
                <div class="w-full">
                  {{ percentOfCorrectAnswers(audience)+ '%' }}
                </div>
                <div class="flex  process-bar-quiz  overflow-hidden rounded  ">
                  <div
                    v-if="percentOfCorrectAnswers(audience)"
                    class=" h-6 pl-2 true-answer-process flex items-center justify-start space-x-2"
                    :style="{
                      width : percentOfCorrectAnswers(audience) + '%'
                    }"
                  >
                    <aha-icon
                      name="correct"
                      width="15"
                      height="15"
                      maintain-color
                      viewBox="0 0 18 18"
                    ></aha-icon>

                    <div>
                      {{ audience.correct_count || 0 }}
                    </div>
                  </div>
                  <div
                    v-if="percentOfInCorrectAnswers(audience) > 0 "
                    class=" h-6 pl-2 wrong-answer-process flex items-center justify-start space-x-1"
                    :style="{
                      width : ( percentOfInCorrectAnswers(audience)) + '%'
                    }"
                  >
                    <aha-icon
                      class="text-red-100"
                      name="incorrect"
                      width="15"
                      height="15"
                      viewBox="0 0 18 18"
                    ></aha-icon>
                    <div>
                      {{ audience.incorrect_count }}
                    </div>
                  </div>
                  <div
                    v-if="percentOfOtherAnswers(audience) > 0"
                    class=" h-6 pl-2 other-answer-process flex items-center justify-start space-x-1"
                    :style="{
                      width : percentOfOtherAnswers(audience) + '%'
                    }"
                  >
                    <img :src="require('@/assets/images/report/other.svg')" />

                    <div>
                      {{ totalAnswer - audience.correct_count - audience.incorrect_count }}
                    </div>
                  </div>
                </div>
              </div>
            </td>

            <td class="mx-6 font-bold spacing-col">
              <div class="wrapper-badge ">
                <div class="w-8">
                  {{ allSlideType(audience) }}
                </div>
                <div
                  v-for="(question,key) in mappingSubmissionCount"
                  :key="key"
                  :class="{
                    'hidden': countSlideType(question , audience) === 0
                  }"
                  class="mr-1"
                  :content="question.title"
                  v-aha-tooltip="{ arrow: true, popperOptions}"
                >
                  <div class="flex items-center justify-center badge-box">
                    <img :src="require(`@/assets/images/report/${question.icon}.svg`)" alt="icon" />
                    <div>
                      {{ countSlideType(question , audience) }}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="totalAudienceAfterSearch === 0 && searchValue.length > 0 ">
      <div class=" w-full text-center flex justify-center items-center h-full  wrapper-empty empty-decs">
        {{ $i18nPresenter.t('No result found') }}
      </div>
    </div>
    <nav
      v-if="totalAudienceAfterSearch && totalAudienceAfterSearch > 0"
      class="flex items-center flex-column flex-wrap md:flex-row justify-between  pagination-report"
    >
      <span
        v-if="totalAudienceAfterSearch && totalAudienceAfterSearch > 0"
        class="text-sm   mb-4 md:mb-0 block w-full md:inline md:w-auto  text-showing"
      >
        <span v-if="searchValue.length > 0">
          {{
            $i18nPresenter.t('Total {x} result(s) found' , {
              total: totalAudienceAfterSearch
            })
          }}
        </span>
        <span v-else>
          {{
            $i18nPresenter.t('Total {x} participant(s)' , {
              total: totalAudience
            })
          }}
        </span>

      </span>

      <AhaPagination
        v-if="totalAudienceAfterSearch && totalAudienceAfterSearch > limit "
        :value="offset"
        class="h-10"
        :totalRows="totalAudienceAfterSearch"
        :perPage="limit"
        @input="changePage"
      />
    </nav>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import debounce from 'debounce'
import ReportMixin from '@/components-v2/presentation-report/ReportMixin'

export default {
  mixins: [ReportMixin],
  data() {
    return {
      limit: 50,
      offset: 1,
      searchValue: '',
      allSlideTypeCount: ['countPollHaveNotCorrect', 'countScale', 'countOpenEnded', 'countQuestion', 'countBrainstorm', 'countWordCloud'],
      mappingSubmissionCount: [
        {
          icon: 'poll', count: ['countPollHaveNotCorrect', 'countScale'], title: 'Vote',
        },
        {
          icon: 'openended', count: ['countOpenEnded'], title: 'Open-ended',
        },
        {
          icon: 'qa', count: ['countQuestion'], title: 'QnA',
        },
        {
          icon: 'brainstorm', count: ['countBrainstorm', 'countWordCloud'], title: 'Brainstorm & Word Cloud',
        },
      ],
      popperOptions: {
        modifiers: {
          preventOverflow: {
            escapeWithReference: true,
          },
        },
      },
    }
  },
  watch: {
    searchValue() {
      this.offset = 1
    },
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      isLoadingAudience: (state) => state.presentationReport.isLoadingAudience,
      audienceReportSummary: (state) => state.presentationReport.audienceReportSummary,
    }),
    listParticipants() {
      return this.audienceReportSummary ? this.audienceReportSummary.reportData : []
    },
    totalAudienceAfterSearch() {
      return this.audienceReportSummary ? this.audienceReportSummary.totalAudienceAfterSearch : 0
    },
    totalAudience() {
      return this.audienceReportSummary ? this.audienceReportSummary.totalAudience : 0
    },
    totalAnswer() {
      return this.audienceReportSummary && this.audienceReportSummary.totalAnswer
    },
    getAudienceSearchPlaceHolder() {
      return this.$i18nPresenter.t('Search participants...')
    },
  },
  mounted() {
    if (this.$route.query.audienceName && this.$route.query.audienceName.length > 1) {
      this.searchValue = this.$route.query.audienceName
    }
    const { id } = this.$route.params
    this.getReport(id)
  },
  methods: {
    ...mapActions('presentationReport', ['getReportAndMetricByPresentationId', 'setAudienceIdShowReport']),
    changePage(page) {
      this.offset = page
      this.getReport(this.presentation.id)
    },
    countSlideType(question, audience) {
      return question.count.map((count) => audience[count]).reduce((a, b) => a + b, 0)
    },
    allSlideType(audience) {
      return this.allSlideTypeCount.map((count) => audience[count]).reduce((a, b) => a + b, 0)
    },

    textRanking(st, audience) {
      if (st == 1) {
        return {
          class: audience.totalPoint !== 0 ? 'first-st ' : 'other-st',
          name: '1st',
          icon: audience.totalPoint !== 0 ? '🥇' : '',

        }
      }
      if (st === 2) {
        return {
          class: audience.totalPoint !== 0 ? 'second-st ' : 'other-st',
          name: '2nd',
          icon: audience.totalPoint !== 0 ? '🥈' : '',
        }
      }
      if (st === 3) {
        return {
          class: audience.totalPoint !== 0 ? 'third-st ' : 'other-st',
          name: '3rd',
          icon: audience.totalPoint !== 0 ? '🥉' : '',
        }
      }
      return {
        class: 'other-st ',
        name: `${st}th`,
        icon: '',
      }
    },
    formatNumberForPoint(num) {
      if (!num) return 0
      if (num >= 10000) {
        return `${(num / 1000).toFixed(1)}k`
      }
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    _onSearchInput: debounce(async function onSearchInputDebounce() {
      this.getReport(this.presentation.id)
    }, 400),

    percentOfCorrectAnswers(audience) {
      return audience ? Math.round((audience.correct_count / this.totalAnswer) * 100) : 0
    },
    percentOfInCorrectAnswers(audience) {
      return audience ? Math.round((audience.incorrect_count / this.totalAnswer) * 100) : 0
    },
    percentOfOtherAnswers(audience) {
      return audience ? (100 - this.percentOfCorrectAnswers(audience) - this.percentOfInCorrectAnswers(audience)) : 0
    },
    async getReport(presentationId) {
      this.getReportAndMetricByPresentationId({
        presentationId,
        offset: this.offset,
        limit: this.limit,
        searchTerm: this.searchValue,
      })
    },
    audienceRowClick(audience) {
      this.$emit('click-audience', audience)
    },
  },
}
</script>
<style lang="scss"  scoped>
$audience-row-hover-color: rgba(240, 244, 250, 0.7);
$audience-row-active-text-color: #4f9af2;
.table-wr{

  .other-answer-process {
    background: #EFF1F7;
    color: #282E3E;
    min-width: 50px;
  }
  .td-accuracy{
    width: 354px;
  }
  .wrapper-empty{
    min-height: 285px;
  }
  .empty-title{
    font-size: 24px;
    font-weight: bold;

  }
  .empty-decs{
    font-size: 16px;
    font-weight: normal;
  }
  .aha-button-base{
    background: white;
  }
  .disable-button{
    opacity: 0.5;
    pointer-events: none;

  }

.wrapper-badge{
 display: flex;
  align-items: center;
  gap:4px;
}
.badge-box {
  padding: 0 0.5rem;
  border: 1px solid #D3D7E1;
  cursor: pointer;
  display: flex;
  gap:2px;
  font-size: 14px;
  border-radius: 2rem;
  @media (max-width: 1453px) {
    padding: 0 0.75rem;
  }
}
.w-leaderboard{
  min-width: 150px;
  width: 150px;
}
.audience-name__header-row {
  min-width: 230px;
}
.total-label-rank {
  @apply flex justify-between font-bold;
  padding: 11.5px 0; // same as .order-number
}
.first-st {
  color: #E6B301;
  background: #FFF7EA;

}

.second-st {
  color: #6C6C6C;
  background: #F0F4FA;
}

.third-st {
  color: #C55719;
  background: #FFF2F3;
}
.other-st{
  border: 1px solid #D3D7E1;
  cursor: pointer;
  display: flex;
  gap:2px;
  border-radius: 17px;
}
  min-height: 285px;
  @media (max-width: 1024px) {
    height:100%;
  }

.table-wrp {
  overflow-y: auto;
  -ms-overflow-style: auto;
  display: block;
  margin-top:16px;
  padding: 0px 16px 16px 16px;
  @media (max-width: 1024px) {
    height:100%;
  }
}

thead {
  position: sticky;
  top: 0;
  color:#848484;
  padding: 5px 0px;
  font-size: 14px;
  background: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.wrapper-list-participant {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.header-list-participant {
  display: contents;
  font-weight: bold;
}

.row-participant {
  display: contents;
}

.wrapper-process-bar-quiz{
  display: grid;
  grid-template-columns: 50px 300px;
  place-items: center;
  gap: 8px;
  font-size: 14px;

}
.process-bar-quiz{
  width: 300px;
  font-size:14px;
}

.label-ranking {
  width: 65px;
  height: 24px;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.true-answer-process {
  background: #d2efec;
  color: #2f8372;
  min-width: 50px;
}

.wrong-answer-process {
  background: #f6dade;
  color: #d3445b;
  min-width: 50px;
}

.wrapper-report {
  background: #F0F4FA;
}
.audience-row {
  @apply cursor-pointer;
  border-radius: 5px;
  border:1px solid transparent;
  &:hover, &:active {
    background-color: $audience-row-hover-color;
  }
  &:active {
    color: $audience-row-active-text-color;
  }
  .item-name-participant {
    &:hover {
      color: $audience-row-active-text-color;
    }
  }
}
.order-number {
  @apply font-bold spacing-col text-center;
  padding: 11.5px 0; // same as .total-label-rank
}
.item-name-participant{
  width: 192px;
  .name-audience{
    max-width: 192px;
  }
}
.spacing-col{
  padding-left: 22px;
}
.item-audience{
  padding:8px;
  color:#848484;
  margin: 4px 0px;

  }
  .item-name-participant{
    width: 192px;
    .name-audience{
      max-width: 192px;
    }
  }
  .spacing-col{
    padding-left: 22px;
  }

  .search_audience_name {
    @apply  w-full;
    .aha-input{
      padding-left: 32px;
    }
  }

  .search_audience_name:hover > .search__icon {
    @apply text-primary-90;
  }

  .search_audience_name:focus-within > .search__icon {
    @apply text-primary-90;
  }

::v-deep .search_audience_name input {
  padding-right: 1.75rem;
  padding-left: 2rem;
  width:auto;
}

.total-submissions__header-row {
  min-width: 300px;
}

  .pagination-report{
    padding: 18px 24px;
    border-top:1px solid #D3D7E1;
    @media (max-width: 1024px) {
      justify-content: center;
      padding-top: 16px;
      text-align: center;
    }
    &::v-deep{
      .pagination.__page.--active > a{
        font-weight: normal;
      }
      .pagination.__back a{
        color:#282E3E;
        &:hover{
          color: #348EF6;
        }
      }
      .pagination.__next a{
        color:#282E3E;
        &:hover{
          color: #348EF6;
        }

      }
      .--disabled{
        opacity: 0.6;
      }
      .pagination.__next  a{
        color:#282E3E;
      }
      .__page{
        border-radius: 4px;
        padding: 2px 6px 2px 6px;
        width: auto;
        height:auto;
        font-weight: normal;
      }
      .--active >  a{
        font-weight: 400;
      }
      .--active{
        &:hover > a{
          color:white;
        }
      }
    }

  }

}

</style>
